import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AiDialogComponent } from './ai-dialog.component';

export interface AiDialogOpenOptions {
  header?: string;
  preferredDomain?: string | null;
  bearerToken?: string; // Optional if your Http interceptor already attaches JWT
}

@Injectable({ providedIn: 'root' })
export class AiDialogService {
  private ref?: DynamicDialogRef;

  constructor(private dialogService: DialogService) {}

  open(options: AiDialogOpenOptions = {}): DynamicDialogRef {
    this.ref?.close();

    this.ref = this.dialogService.open(AiDialogComponent, {
      header: options.header ?? 'AI Assistant',
      width: 'min(900px, 96vw)',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 11000,
      data: {
        preferredDomain: options.preferredDomain ?? null,
        bearerToken: options.bearerToken
      }
    });

    return this.ref;
  }

  close(): void {
    this.ref?.close();
    this.ref = undefined;
  }
}
